import {
  DarkTheme as NavigationDarkTheme,
  DefaultTheme as NavigationDefaultTheme
} from '@react-navigation/native';
import {
  MD3DarkTheme,
  MD3LightTheme,
  adaptNavigationTheme,
  configureFonts
} from 'react-native-paper';

import { colors } from '@/styles/colors/colors';

const { LightTheme, DarkTheme } = adaptNavigationTheme({
  reactNavigationLight: NavigationDefaultTheme,
  reactNavigationDark: NavigationDarkTheme
});

const fontConfig = {
  displayLarge: { fontFamily: 'Montserrat_500Medium' },
  displayMedium: { fontFamily: 'Montserrat_500Medium' },
  displaySmall: { fontFamily: 'Montserrat_500Medium' },
  headlineLarge: { fontFamily: 'Montserrat_500Medium' },
  headlineMedium: { fontFamily: 'Montserrat_500Medium' },
  headlineSmall: { fontFamily: 'Montserrat_500Medium' },
  titleLarge: { fontFamily: 'Montserrat_500Medium' }
};

export const CombinedDefaultTheme = {
  ...MD3LightTheme,
  ...LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    ...LightTheme.colors,
    ...colors.light
  },
  rippleColors: {
    onPrimary: 'rgba(255, 255, 255, 0.2)',
    onSurface: colors.light.surfaceDisabled
  },
  stateLayers: {
    hover: colors.light.surfaceDisabled
  },
  // See: https://github.com/callstack/react-native-paper/issues/4540
  fonts: {
    ...MD3LightTheme.fonts,
    ...NavigationDefaultTheme.fonts,
    ...configureFonts({ config: fontConfig })
  }
};

export type AppTheme = typeof CombinedDefaultTheme;

export const CombinedDarkTheme: AppTheme = {
  ...MD3DarkTheme,
  ...DarkTheme,
  colors: {
    ...MD3DarkTheme.colors,
    ...DarkTheme.colors,
    ...colors.dark
  },
  rippleColors: {
    onPrimary: 'rgba(255, 255, 255, 0.2)',
    onSurface: colors.dark.surfaceDisabled
  },
  stateLayers: {
    hover: colors.dark.surfaceDisabled
  },
  fonts: {
    ...MD3DarkTheme.fonts,
    ...NavigationDefaultTheme.fonts,
    ...configureFonts({ config: fontConfig })
  }
};
